import { graphql, useStaticQuery } from "gatsby";
import { FaqItemContent } from "@app/components/common/faq-group/components/faq-item/types";

type FAQItem = {
  uuid: string;
  question: FaqItemContent;
};

export const useFaqLibrary = (
  lang: string,
  isApp = false,
  questionIds?: string[],
) => {
  const { questionsPool } = useStaticQuery(graphql`
    {
      questionsPool: allStoryblokEntry(
        filter: { field_component: { eq: "faqLibraryItem" } }
      ) {
        edges {
          node {
            content
            full_slug
            uuid
            lang
          }
        }
      }
    }
  `);

  const localizedQuestionsPool = questionsPool.edges
    .filter((faqItemNode) =>
      questionIds?.length
        ? questionIds.includes(faqItemNode.node.uuid) &&
          faqItemNode.node.lang === lang
        : faqItemNode.node.lang === lang,
    )
    ?.map((faqItemNode) => ({
      uuid: faqItemNode.node.uuid,
      content: faqItemNode.node.content,
      fullSlug: faqItemNode.node.full_slug,
    }));

  const sortedQuestions = questionIds?.length
    ? questionIds
        .map(
          (questionId) =>
            localizedQuestionsPool.filter(
              (question) => question.uuid === questionId,
            )[0],
        )
        .filter((question) => question)
    : localizedQuestionsPool;

  const mapedSortedQuestions: FAQItem[] = sortedQuestions.map((question) => ({
    uuid: question.uuid,
    question: JSON.parse(question.content),
  }));

  return isApp
    ? mapedSortedQuestions.filter(
        (question) => !question.question.isHiddenInApp,
      )
    : mapedSortedQuestions;
};
